export default "__VITE_ASSET__DQEzMqTF__"